import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6980ef16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bag-business" }
const _hoisted_2 = { style: {"margin-left":"10px","margin-bottom":"10px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "el-upload-list__item-actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "bag-business-bt" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 我已经阅读")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("《招盟经销商业务合作协议》")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("并同意严可先遵守其中的约定 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("提交申请")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("撤回申请")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_16 = ["src"]

import { Plus, UploadFilled } from "@element-plus/icons-vue";
import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import type {
  UploadFile,
  ElUploadProgressEvent,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

interface activityVo {
  id: string;
  type: string;
  status: number;
  auditStatus: number;
  joinQuantity: string;
  request: string;
  brandDesc: string;
  conditionDesc: string;
  processDesc: string;
  joinCategoryIds: string;
  tempJoinCategoryIds: string[];
  activityImages: activityImageVo[];
  imgUrlJson: string;
  areaIds: string;
}
interface activityImageVo {
  uid:number;
  imgUrl: string;
  thumbnailUrl: string;
  url: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const isEdit = ref(true);
const checked = ref(false);
const selectAreaProps = {
   multiple: true,
   checkStrictly: true,
   emitPath: true,
}

const createOrEditFormData: activityVo = {
  id: "",
  type: "7",
  status: 1,
  auditStatus: 0,
  joinQuantity: "",
  request: "",
  brandDesc: "",
  conditionDesc: "",
  processDesc: "",
  joinCategoryIds: "",
  tempJoinCategoryIds: [],
  activityImages: [],
  imgUrlJson: "",
  areaIds: "",
};
const bindData = reactive({
  createOrEditFormData: createOrEditFormData,
  projects: [],
  joinCategorys: [],
  actionUrl: tool.url("/personalCenter/uploadActivityImg"),
  joinCategoryName:"",
  areaIdArray: Array<Array<String>>(),
});

const updateApplyBtnEvent = () => {
  if (checked.value) {
    isEdit.value = true;
    checked.value = false;
  } else {
    isEdit.value = false;
    checked.value = true;
  }
};

const saveEvent = () => {
  var joinCategoryIds = "";
  var tempJoinCategoryIds = bindData.createOrEditFormData.tempJoinCategoryIds;
  if (tempJoinCategoryIds) {
    for (var value of tempJoinCategoryIds) {
      if (!joinCategoryIds) {
        joinCategoryIds = value;
      } else {
        joinCategoryIds = joinCategoryIds + "," + value;
      }
    }
  }
  bindData.createOrEditFormData.status = 2;
  bindData.createOrEditFormData.joinCategoryIds = joinCategoryIds;
  bindData.createOrEditFormData.imgUrlJson = JSON.stringify(
    bindData.createOrEditFormData.activityImages
  );
  store
    .dispatch("businessModule/saveTemporaryInfo", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.createOrEditFormData.id = data.result;
        ElMessage.success(data.msg);
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const recallApplyEvent = (status: number) => {
  var id = bindData.createOrEditFormData.id;
  if ("add" == id) {
    bindData.createOrEditFormData.id = "";
  }
  var msg = "您确定要结束加盟吗?";
  if (status == 1) {
    var msg = "您确定要撤回申请吗?";
  }
  ElMessageBox.confirm(msg)
    .then(() => {
      const params = {
        id: id,
        status: status,
      };
      store.dispatch("businessModule/recallApply", params).then(
        (data) => {
          //成功
          ElMessage.success("成功.");
          activityEvent();
          activityImageEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

const joinCategoryEvent = () => {
  store
    .dispatch("businessModule/listJoinCategory", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.joinCategorys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

 const saveJoinCategoryEvent = () => {
        store
          .dispatch("investModule/saveJoinCategory", {joinCategoryName:bindData.joinCategoryName})
          .then(
            (data) => {
               ElMessage.success("成功.");
               joinCategoryEvent();
               bindData.joinCategoryName = "";
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };

const activityEvent = () => {
  store
    .dispatch("businessModule/getActivity", bindData.createOrEditFormData)
    .then(
      (data) => {
        console.log(data);
        if (data.result) {
          bindData.createOrEditFormData = data.result;
          if (data.result.images) {
            bindData.createOrEditFormData.activityImages = data.result.images;
          }
          var joinCategoryIds = bindData.createOrEditFormData.joinCategoryIds;
          if (joinCategoryIds) {
            bindData.createOrEditFormData.tempJoinCategoryIds =
              joinCategoryIds.split(",");
          }
          bindAreaData(bindData.createOrEditFormData.areaIds);
        } else {
           const activityVo = {
                  id: "",
                  type: "7",
                  status: 1,
                  auditStatus: 0,
                  joinQuantity: "",
                  request: "",
                  brandDesc: "",
                  conditionDesc: "",
                  processDesc: "",
                  joinCategoryIds: "",
                  tempJoinCategoryIds: [],
                  activityImages: [],
                  imgUrlJson: "",
                  areaIds:"",
           }
           bindData.createOrEditFormData =activityVo;
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activityImageEvent = () => {
  store
    .dispatch("businessModule/listActivityImage", bindData.createOrEditFormData)
    .then(
      (data) => {
        //成功
        bindData.createOrEditFormData.activityImages = [];
        for (var image of data.result) {
          const imageFile: activityImageVo = {
            uid:image.uid,
            imgUrl: image.imgUrl,
            thumbnailUrl: image.thumbnailUrl,
            url: image.thumbnailUrl,
          };
          bindData.createOrEditFormData.activityImages.push(imageFile);
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

joinCategoryEvent();
activityEvent();
//activityImageEvent();

const toBusiness = () => {
  router.push("/middleGround/member/businessList");
};

const handleRemove = (file: UploadFile) => {
  const activityImages = bindData.createOrEditFormData.activityImages;
  bindData.createOrEditFormData.activityImages = [];
  //成功
  for (var image of activityImages) {
    if (image.url != file.url) {
      bindData.createOrEditFormData.activityImages.push(image);
    }
  }
};

const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!;
  dialogVisible.value = true;
};

const uploadSuccessEvent = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  const imageFile: activityImageVo = {
    uid:file.uid,
    imgUrl: response.result.imgUrl,
    thumbnailUrl: response.result.thumbnailUrl,
    url: file.url!,
  };
  bindData.createOrEditFormData.activityImages.push(imageFile);
};

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  debugger;
  const areass = value as Array<Array<string>>;
  bindData.areaIdArray = areass;
  const areaStrArray = Array<string>(areass.length);
  for(var i = 0; i < areass.length; i++) {
    var areas = areass[i];
    var areaNames = Array<string>(areas.length);
    for(var j = 0; j < areas.length; j++) {
      var areaName = tool.areaCodeToText.get(areas[j]);
      if(areaName) {
        areaNames[j] = areaName;
      }
    }
    areaStrArray[i] = areaNames.join("-");
  }
  if(areaStrArray.length > 0) {
    bindData.createOrEditFormData.areaIds = areaStrArray.join(";");
  }
};

const bindAreaData = (areaIdsArrayStr: string) => {
   debugger;
  if (areaIdsArrayStr && areaIdsArrayStr.length > 0) {
    var areaIdsArray = areaIdsArrayStr.split(";");
    var areaIdss = Array<Array<string>>(areaIdsArray.length);
    for (var i = 0; i < areaIdsArray.length; i++) {
      var areas = areaIdsArray[i].split("-");
      var areaIds = Array<string>(areas.length);
      for(var j = 0; j < areas.length; j++) {
        var areaId = tool.areaTextToCode.get(areas[j]);
        if(areaId) {
          areaIds[j] = areaId;
        }
      }
      areaIdss[i] = areaIds;
    }
    bindData.areaIdArray = areaIdss;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _unref(bindData).createOrEditFormData,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "招募品类" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _unref(bindData).createOrEditFormData.tempJoinCategoryIds,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).createOrEditFormData.tempJoinCategoryIds) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).joinCategorys, (item) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: item.id,
                      label: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).joinCategoryName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).joinCategoryName) = $event)),
                onBlur: saveJoinCategoryEvent,
                "input-style": "width:100px;float:right",
                placeholder: "自定义",
                size: "default"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "招募地区" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(bindData).areaIdArray,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).areaIdArray) = $event)),
              props: selectAreaProps,
              size: "large",
              filterable: "true",
              clearable: "true"
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "招募数量" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.joinQuantity,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).createOrEditFormData.joinQuantity) = $event)),
              "input-style": "width:100px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "品牌说明" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.brandDesc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).createOrEditFormData.brandDesc) = $event)),
              "input-style": "width:500px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "业务介绍" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "bag-business-textarea",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.request) = $event))
            }, null, 512), [
              [_vModelText, _unref(bindData).createOrEditFormData.request]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "条件" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "bag-business-textarea",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.conditionDesc) = $event))
            }, null, 512), [
              [_vModelText, _unref(bindData).createOrEditFormData.conditionDesc]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "流程" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "bag-business-textarea",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.processDesc) = $event))
            }, null, 512), [
              [_vModelText, _unref(bindData).createOrEditFormData.processDesc]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "海报" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              action: _unref(bindData).actionUrl,
              "file-list": _unref(bindData).createOrEditFormData.activityImages,
              "on-success": uploadSuccessEvent,
              "list-type": "picture-card",
              "auto-upload": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              file: _withCtx(({ file }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_6),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["action", "file-list"]),
            _createVNode(_component_el_dialog, {
              modelValue: dialogVisible.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogVisible).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  width: "100%",
                  src: dialogImageUrl.value,
                  alt: ""
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_9, [
      (
          _unref(bindData).createOrEditFormData.status == 1 ||
          _unref(bindData).createOrEditFormData.status > 2
        )
        ? (_openBlock(), _createBlock(_component_el_container, {
            key: 0,
            class: "bag-business-check"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: checked.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((checked).value = $event)),
                onClick: _withModifiers(updateApplyBtnEvent, ["prevent"])
              }, null, 8, ["modelValue", "onClick"]),
              _hoisted_10,
              _createVNode(_component_el_link, { type: "primary" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _hoisted_12
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_container, { class: "bag-business-btn" }, {
        default: _withCtx(() => [
          (
            _unref(bindData).createOrEditFormData.status == 1 ||
            _unref(bindData).createOrEditFormData.status > 2
          )
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "bag-business-btn-w",
                disabled: isEdit.value,
                type: "primary",
                size: "large",
                onClick: saveEvent
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (
            _unref(bindData).createOrEditFormData.status > 1 &&
            _unref(bindData).createOrEditFormData.status < 3
          )
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 1,
                class: "bag-business-btn-w",
                size: "large",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (recallApplyEvent(1)))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(ElButton), {
            class: "bag-business-btn-w",
            size: "large",
            onClick: toBusiness
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          width: "100%",
          src: dialogImageUrl.value,
          alt: ""
        }, null, 8, _hoisted_16)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})